import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'
import { getPixelDistance } from '../util/mapbox-util';
import { useSelector, useDispatch } from 'react-redux'

// import moment from 'moment'
import moment from 'moment'
// import momentDurationFormatSetup from 'moment-duration-format'

import mapboxgl from 'mapbox-gl';
import ViewportItemStatePopup from './ViewportItemStatePopup';

export default function ViewportItemState(props) {
  const map = useSelector((state) => state.ui.map)
  const lastStateVisible = useSelector((state) => state.ui.itemLastStateVisible[props.viewportItemId]) ;
  const trajectoryVisible = useSelector((state) => state.ui.itemTrajectoryVisible[props.viewportItemId]) ;
  const lastState = useSelector((state) => state.viewport.itemMoLastStates[props.viewportItemId]) ;
  const stats = useSelector((state) => state.viewport.itemMoStats[props.viewportItemId]) ;
  const viewportItemZoomTo = useSelector((state) => state.ui.viewportItemZoomTo) ;

  const chartVisible = useSelector((state) => state.ui.itemChartVisible[props.viewportItemId]) ;
  const conf = useSelector((state) => state.ui.viewportItemConfigs[props.viewportItemId]) ;
  // item config elements: 
  const profilePicture = ( conf ? conf.profilePicture : null) ;
  const profilePictureWidth = ( ( conf ? conf.profilePictureWidth : null ) 
                                ? conf.profilePictureWidth : PROFILE_PICTURE_WIDTH) ; 
  const profilePictureOpacity = (conf ? conf.profilePictureOpacity : null) ; 
  const directLink = (conf ? conf.directLink : null) ;

  // refs: 
  const effectWorking = useRef(false) 
  const elDivRef = useRef( null) 
  const markerRef = useRef(null) 
  const popupRef = useRef( null) 
  const popupDivRef = useRef(null)
  const zoomToItemRef = useRef(null)
  const lastScaleRef = useRef(null)
  const markerTimeoutRef = useRef(null) 
  const markerOldPosRef = useRef(null) 

  // div needed for ViewportItemStatePopup rendering by react
  if (popupDivRef.current == null)  popupDivRef.current = document.createElement('div');

  const endMarkerId = "endMarker-" + props.viewportItemId ;
  
  const scaleMarker = (scale) => {
    if (! lastState) return;
    if (Object.keys(lastState).length === 0 && lastState.constructor === Object ) return ;
    // if there is no huge difference, don't update (makes transition smoother)
    if (lastScaleRef.current!=null && Math.abs(lastScaleRef.current - scale) < 0.01 ) return 

    // compute profile picture width
    var ppWidth = 0 
    if (! profilePicture) ppWidth = GENERIC_PROFILE_PICTURE_WIDTH
    if (profilePictureWidth) ppWidth = profilePictureWidth 
    if (props.focused) ppWidth = FOCUSED_PROFILE_PICTURE_WIDTH
    ppWidth = ppWidth*scale

    // fix text height
    var bordersize = Math.round( ppWidth / 13.0)
    var textheight = Math.round((12*scale) * (ppWidth / (30*scale)))
    if (textheight > 20) textheight = 20 
    if (textheight < 4) textheight = 4

    var markerwidth = ppWidth + (bordersize * 2)
    var markerHeight = Math.round( (402*scale) / ( 299*scale / markerwidth))

    // positions: two images (frame, photo)
    elDivRef.current.style.backgroundPosition = "0px " + (textheight) + "px, " +
                                       bordersize + "px " + (textheight + bordersize) + "px " ;

    // scale label font size according to the marker size:   
    elDivRef.current.style.fontSize = textheight + "px" // (140 * ppWidth / 30) + "%" ;

    elDivRef.current.style.width = markerwidth + 'px' ;
    elDivRef.current.style.height = markerHeight + textheight + 'px';
    elDivRef.current.style.backgroundSize = markerwidth + 'px ' + 
                                      markerHeight + 'px, ' +
                                      ppWidth + 'px, ' + 
                                      ppWidth + 'px' ;
    //this.marker.setElement(el)
    markerRef.current.setOffset([0, - markerHeight/2])

    lastScaleRef.current = scale 
  }
   
  const scaleMarkerByZoomLevel = () => {
    var zoomLevel = map.getZoom() 
    var scale = 1
    // for keknap:
    // 9-10.5 között túl nagy
    if ((typeof SCALE_MO_MARKER !== "undefined") && (SCALE_MO_MARKER)) {
      //if (zoomLevel < 7.0) scale = 0.11
      const zoomMin = 0.07 // 0.11
      if (zoomLevel < 7.0) scale = zoomMin
      else if (zoomLevel > 12) scale = 1
      else scale = zoomMin + (zoomLevel-7.0)/5.0*0.89
    }
    return scaleMarker(scale)
  }
  const scaleUpClickedMarker = () => {
    if (!props.focused) scaleMarker(1.5)
  }
  const scaleResetMarker = () => {
    if (!props.focused) scaleMarker(1.0)
  }  


  // lazy create popup
  const createPopup = () => { 
    if (POPUPS_DISABLED) return
    // only create if not exists already
    // console.log("createPopup: ", popupDivRef.current)
    //if (elDivRef.current == null) {
    //  console.log("creating eldivref")
    //  const el = document.createElement('div');
    //  el.className = 'marker';
    //  // marker-frame-narrow-inactive-noshadow.png
    //  // marker-with-head-active-noshadow.png
    //  el.style.opacity = ( profilePictureOpacity ? profilePictureOpacity : 1 ) ;
    //  var text = document.createTextNode(props.shortName) ;
    //  // remove and add text element
    //  while (el.firstChild) el.removeChild(el.lastChild);
    //  el.appendChild(text);  
    //  
    //  el.addEventListener('click', function(e){
    //    console.log('marker div click event.')
    //    createPopup() 
    //    markerRef.current.setPopup(popupRef.current)
    //    // Prevent the `map.on('click')` from being triggered
    //    // e.stopPropagation();
    //  });
    //}
    if (popupRef.current == null) {
      const popup = new mapboxgl.Popup({
        closeButton: true,
        closeOnClick: true,
        anchor: 'top',
        offset: [0, 0]
      })
      
      // display large profile picture when popup is displayed 
      
      // TODO: 
      // popup.on('open', scaleUpClickedMarker());
      // popup.on('close', scaleResetMarker());  

      if (directLink) {
        popup.on('open', () => { 
          window.open(directLink,'_blank');
          //popup.remove()
        });
      }
      popupRef.current = popup
      
      popup.setDOMContent(popupDivRef.current)

      if (( typeof lastState != "undefined" )  && ( lastStateVisible) ) {
        popup.setLngLat([lastState.lon, lastState.lat])
        //const oldpos = popup.getLngLat()
        //updatePopupPosition(popup, oldpos.lng, oldpos.lat, 
        //                    lastState.lon, lastState.lat, 0)
        
      }
    }
  }

  //const steps = 6;
  function animateMarkerTo(marker, startLng, startLat, targetLng, targetLat,
                           delayMsec, steps, currentStep, reset) {
    let currentLng = startLng + (targetLng - startLng) * (currentStep / steps);
    let currentLat = startLat + (targetLat - startLat) * (currentStep / steps);
    marker.setLngLat([currentLng, currentLat]);
    // delete previous setTimeout:
    if (reset && (typeof markerTimeoutRef.current !== null)) {
      clearTimeout(markerTimeoutRef.current)
      markerTimeoutRef.current = null
    }
    if (currentStep < steps) {
        markerTimeoutRef.current = setTimeout(() => 
        animateMarkerTo(marker, startLng, startLat, targetLng, targetLat, 
                        delayMsec, steps, currentStep + 1, false), 
            delayMsec / steps);
    }
    else {
      markerTimeoutRef.current = null      
    }

  }
 
  useEffect(() => {
    // only update when possible, and when the previous update is finished
    //if (props.viewportItemId==3089) 
    //  console.log(`${props.viewportItemId}: ( typeof lastState == "undefined" ): ${( typeof lastState == "undefined" )} ` + 
    //              `(! lastStateVisible): ${(! lastStateVisible)} ` +
    //              `(! map): ${(! map)} ${(effectWorking.current) } ${ (markerTimeoutRef.current !== null)}`)
    if (( typeof lastState == "undefined" )  || (! lastStateVisible)  || (! map) ||
         (effectWorking.current) || (markerTimeoutRef.current !== null) ) {
      // markerRef.current.remove()
      return 
    }
    else {
      effectWorking.current = true

      // marker is permanent, is stored as a ref: 
      if (elDivRef.current == null) {
        const el = document.createElement('div');
        el.className = 'marker';
        el.style.opacity = ( profilePictureOpacity ? profilePictureOpacity : 1 ) ;
        var text = document.createTextNode(props.shortName) ;
        // remove and add text element
        while (el.firstChild) el.removeChild(el.lastChild);
        el.appendChild(text);  
        
        el.addEventListener('click', function(e){
          // console.log('marker div click event.')
          createPopup() 

          markerRef.current.setPopup(popupRef.current)
          // Prevent the `map.on('click')` from being triggered
          // e.stopPropagation();
        });
      
        elDivRef.current = el
      }   

      if (markerRef.current==null) {
        markerRef.current = new mapboxgl.Marker(elDivRef.current)
        markerRef.current.setLngLat([lastState.lon, lastState.lat])
        markerRef.current.addTo(map);
        scaleMarker(1)
      }        
      if (markerRef.current._map !== map) markerRef.current.addTo(map);
      
      // use different profile picture frame for inactive items
      var isActive = true
      if (Math.abs(moment().diff( moment(parseInt(lastState.time)), 'minutes')) > 15)
        isActive = false
    
      // set marker background image:
      var bgimg ;
      if (profilePicture) {
        if (isActive) {
          bgimg = 'url(https://movingobject.co/img/marker-frame-narrow-active-noshadow.png), ' +
                  'url(' + profilePicture + ')'
        }
        else {
          bgimg = 'url(https://movingobject.co/img/marker-frame-narrow-inactive-noshadow.png), ' +
                  'url(' + profilePicture + ')'
        }
      }
      else {      
        if (isActive) {
          if ( typeof MARKER_ACTIVE !== "undefined" ) bgimg = MARKER_ACTIVE ;
          else bgimg = 'url(https://movingobject.co/img/marker-with-head-active-noshadow.png) ';
        }
        else {
          if (typeof MARKER_INACTIVE !== "undefined") bgimg = MARKER_INACTIVE;
          else bgimg = 'url(https://movingobject.co/img/marker-with-head-inactive-noshadow.png) ';
        }      
      }    
      elDivRef.current.style.backgroundImage = bgimg;

      // move marker: 
      const oldPos = markerRef.current.getLngLat() 
      const pdist = getPixelDistance(map, oldPos, [lastState.lon, lastState.lat])
      //console.log(pdist)
      const ttime = new Date().getTime()
      if (pdist > 5) {
        if (pdist < 30) {
          // move marker
          markerRef.current.setLngLat([lastState.lon, lastState.lat])
        }
        else {
         if (markerOldPosRef.current != null) {
            animateMarkerTo(markerRef.current, 
              markerOldPosRef.current[0], markerOldPosRef.current[1], 
              lastState.lon, lastState.lat, 
              // new Date().getTime() - markerOldPosRef.current[2],
              0,
              3, 0, true)
          }
          else {
            markerRef.current.setLngLat([lastState.lon, lastState.lat])  
          }
        }
        markerOldPosRef.current = [lastState.lon, lastState.lat, ttime]
      }
      
      scaleMarkerByZoomLevel()
      
      
      // marker popup: 
      // TODO: 
      //popup.off('open', this.scaleUpClickedMarker.bind(this));
      //popup.off('close', this.scaleResetMarker.bind(this));
      //popup.remove() 
            
 
      // BUG: scrolls to the iframe; might be needless anyway: 
      // if direct clickable link is provided, do only the clickthrough
  
      map.on('zoomend', scaleMarkerByZoomLevel) 
      effectWorking.current = false
    }

    return () => {
      //console.log("useEffect cleanup: ", props.viewportItemId)
      if (effectWorking.current) console.log("ViewportItemState update congestion.")

      if (markerRef.current!=null) markerRef.current.remove()
      
      if (popupRef.current !=null) {
        popupRef.current.off('open', scaleUpClickedMarker());
        popupRef.current.off('close', scaleResetMarker());        
        popupRef.current.remove() 
      }
      //map.off('zoomend', scaleMarkerByZoomLevel)

      // this.map.off('styledata', this.forceUpdate)      
    }
  }, [map, lastState, lastStateVisible])
  

  // rázoom-olás eseményekhez: 
  useEffect(() => {
    if ( map && viewportItemZoomTo && lastState && (props.viewportItemId == viewportItemZoomTo) ) {
      map.flyTo({
        center: [lastState.lon, lastState.lat],
        essential: true,
        zoom: 12 
        });
    }
  }, [viewportItemZoomTo])

  // no map rendering when lastState is unknown
  if ( (lastState == null) || (! lastStateVisible ) ||
    ( Object.keys(lastState).length === 0 && lastState.constructor === Object) ) {      
    return  ;  
  }

  // TODO: if no popup was shown before, no need for popup content
  // if (popupRef.current == null) return ;

  // render popup (cannot embed it in component's render method)
  if (map && ! POPUPS_DISABLED) {
    return ReactDOM.createPortal(
      (
        <>
            <ViewportItemStatePopup shown={true /* (popupRef.current != null)*/ }
                                    store={props.store} 
                                    map={map} 
                                    location={props.location}
                                    lastState={lastState}
                                    stats = {stats} 
                                    displayName = {props.displayName}
                                    viewportItemKey = {props.viewportItemKey}
                                    viewportItemId = {props.viewportItemId}
                                    focused={props.focused}
                                    trajectoryVisible={trajectoryVisible}
                                    lastStateVisible = {lastStateVisible}
                                    setLastStateVisibility = {props.setLastStateVisibility}
                                    setTrajectoryVisibility = {props.setTrajectoryVisibility}                      
                                    />
        </>
      ),
      popupDivRef.current
    );
  }
  else return 
}  
